import React from 'react'
import { Link } from 'react-router-dom'
import AuthHeader from './AuthHeader'
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import StyledButton from './inputs/StyledButton'
import BlueTypography from './typography/BlueTypography';

class PasswordCreated extends React.PureComponent {
  render() {
    return (
      <section className="header">

        <AuthHeader />

         <div className="inner bottom-gap">
          <Grid container spacing={0} justify="center">
            <Grid item xs={12} md={4}>
              <Paper className="no-boxshadow">

                <div className="mdc-instalevel-text-field-container">

                  <BlueTypography
                    variant="display1"
                    align="center"
                    className="ls-025 mb-24"
                  >
                    You have a new password
                  </BlueTypography>


                  <StyledButton
                    component={Link}
                    to="/"
                    size="small"
                    type="submit"
                    aria-label="SIGN IN"
                    variant="contained"
                    className="mdc-instalevel-w-100 ls-125"
                  >SIGN IN</StyledButton>


                </div>

              </Paper>
            </Grid>
          </Grid>
        </div>
      </section>
    )
  }
}

export default PasswordCreated



// WEBPACK FOOTER //
// ./src/js/components/PasswordCreated.js